import {ReactNode, useEffect, useState} from 'react'
import {selectGlobalDialogState} from '../../../../../redux/ducks/GlobalDialog/slice';
import {useAppSelector} from '../../../../../redux/hooks';
import ArgosCollapseComponent from '../../../../components/CollapseComponent/ArgosCollapseComponent';
import ArgosFlexbox from '../../../../components/Containers/ArgosFlexbox';
import ArgosTextField from '../../../../components/Form/TextField/ArgosTextField';
import { Ultrasonic } from '../../constants';


interface UltrasonicDescriptionProps {
  sensor: Ultrasonic
}

const SensorDescription = (props: UltrasonicDescriptionProps) => {
  const [sensorDescriptionDataMap, setDataMap] = useState<any>({})
  const [radarDescriptionData, setRadarDescriptionData] = useState(props.sensor)

  useEffect(() => {
    makeTabs()
  }, [])

  const makeTabs = () => {
    const tabs: any[] = [];
    const dataMap: object = {
      'General Information': processGeneralInfoData(),
      'Sensitivity, Range, Field of View': processSRFOVInfoData(),
      'Link Budget': processLinkBudgetInformation()
    }
    setDataMap(dataMap)
  }

  function processGeneralInfoData() {
    const generalInfoLabelsMapping: object[] = [
      {'Supplier Name': 'supplier'},
      {'Component Name': 'component'},
      {'Component Type': 'ultrasonicType'},
      {'Component Version/Revision': 'componentVersion'}]

    return mapLabelToUltrasonicValue(generalInfoLabelsMapping)

  }

  function processSRFOVInfoData() {
    const SRFOVInfoLabels = [
      {'Sensor degradation due to manufacturing variation (dB)': 'detectionDegradation'},
      {'Maximum instrumented range (m)': 'maxInstrumentedRange'},
      {'Maximum instrumented field of view - Azimuth (+/- deg)': 'azimuthFOV'},
      {'Maximum instrumented field of view - Elevation (+/- deg)': 'elevationFOV'}
    ]
    return mapLabelToUltrasonicValue(SRFOVInfoLabels)
  }

  function processLinkBudgetInformation() {
    const linkBudgetInfo = [
      {' Transmit power at hot (i.e., at max MMIC junction temperature, Tj )': 'txPowerHot'},
      {'Single side band noise figure at hot (i.e., at max MMIC Tj )': 'singleSideBandNoiseHot'},
      {'Two way antenna gain at hot': 'twoWayAntannaGainHot'},
      {'Number of firing modes': 'numOfFiringModes'},
      {'Ultrasonic frequency (MHz)': 'ultrasonicFreq'},
      {'Total Measurement Cycle': 'totalMeasurementCycle'},
      {'Worst case membrane description (metal content, number of paint layers)': 'worstCaseDescription'},
      {'Worst case painted membrane degradation (dB)	': 'worstCaseDegradation'}
    ]
    return mapLabelToUltrasonicValue(linkBudgetInfo)
  }

  function mapLabelToUltrasonicValue(mappingList: object[]) {
    const returnList: any[] = []
    mappingList.forEach((labelObject: object) => {
      returnList.push({
        'label': Object.keys(labelObject)[0],
        'value': radarDescriptionData[Object.values(labelObject)[0] as keyof Ultrasonic]
      })
    })
    const returnComponent: ReactNode = <ArgosFlexbox
      style={{display: "flex", flexFlow: 'row wrap', justifyContent: "center", maxWidth: "90%"}}>
      {returnList.map((mapElement, index) =>
        <ArgosTextField
          key={index}
          style={{width: "600px", gap: "10px 10px"}}
          value={mapElement.value}
          name={mapElement.label}
          id="outlined-basic"
          label={mapElement.label}
          variant="outlined"
          size="small"
          className='grid-item'
          InputProps={{
            readOnly: true,
          }}/>)
      }
    </ArgosFlexbox>

    return returnComponent
  }

  return (
    <ArgosCollapseComponent componentType="sensorDescription" data={sensorDescriptionDataMap}/>
  )
}
export default SensorDescription;